
const SecretarySection = ({hideElem}) => { 
  return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">
        {!hideElem && (
          <div className="row justify-content-center mt-3 pb-4">
            <div className="col-md-12  heading-section ftco-animate text px-4">
              <h2 className="mb-4 text-success text-center">
                <span className="text-warning">Management </span> Team
              </h2>
            </div>
          </div>
        )}

        <div className="row mt-3">
          <div className=" col-md-12 order-md-first ">
            <div className="text px-4">
              <h2 className="mb-4 text-primary"> Secretary’s Message </h2>
              <p>
              Greetings. Kaamadhenu College of Education is committed to providing quality teacher
education in a supportive and academically sound environment. As the Secretary of the
institution, I am pleased to be associated with a college that places importance on
professional preparation, value orientation, and continuous development of future teachers. </p>

<p>The institution strives to offer appropriate academic programmes, essential infrastructure, and
student support services to facilitate meaningful learning experiences. Our focus is on
equipping student teachers with the necessary knowledge, pedagogical skills, and
professional attitudes required for effective teaching and responsible participation in the
education system. </p>
<p>At Kaamadhenu College of Education, we encourage students to engage actively in academic
activities and to make responsible use of the opportunities provided for their personal and
professional growth. The collective efforts of the management, faculty, and staff aim to create
a learning environment that supports academic progress and holistic development. </p>
<p>I extend my best wishes to all students for a purposeful and successful academic journey and
hope that they contribute positively to the field of education and to society.
              </p>
              <h5 className='font-weight-bold text-left'>With best wishes,<br/>Ms P. Arunthathi,<span className="qualification">B.E., M.S.,</span> <br />Secretary</h5>
              
             </div>
          </div>
        </div>  
      </div>  
      <hr className="custom-hr"/>
    </section>
  );
};

export default SecretarySection;
